// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"363e8306","231":"396a2fab","343":"a31c5ac7","531":"395efa36","628":"566f2c74","679":"7aed45e1","823":"6e5f099d","904":"4259df00","991":"89bf5ad1"}[chunkId] + ".chunk.js";
};